/* Aesthetics Brothers: look "aesthetics" (2026-10-21). Va junto con ab-look.css.
   1) Sabores / tallas en botones: arma un botón por cada opción del selector #variant-select
      (snippets/product-form.liquid). El selector original sigue mandando el pedido; los botones
      solo cambian su valor y disparan "change", así siguen funcionando la foto por sabor,
      el stock y la tabla de mayoreo.
   2) Mayoreo en pestaña: mete la tabla #ab-tabla-escala (la dibuja ab-min-3.js) en una pestaña.
   3) Secciones que aparecen con un desvanecido al bajar.
   Para quitarlo, borra las líneas que cargan ab-look.css y ab-look.js en layout/theme.liquid. */
(function(){
  var MAX_BOTONES = 40; /* con más opciones se deja la lista desplegable */

  /* ---------- 1. Sabores en botones ---------- */
  function sabores(){
    var sel = document.getElementById('variant-select');
    if (!sel || sel.getAttribute('data-ab-sab')) return;
    var opts = sel.options;
    if (opts.length < 2 || opts.length > MAX_BOTONES) return;
    sel.setAttribute('data-ab-sab', '1');
    var box = document.createElement('div');
    box.className = 'ab-sab';
    box.setAttribute('role', 'radiogroup');
    var lbl = document.querySelector('label[for="variant-select"]');
    if (lbl) box.setAttribute('aria-label', lbl.textContent.trim());
    for (var i = 0; i < opts.length; i++){
      (function(o){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.textContent = o.textContent.replace(/\s+/g, ' ').trim();
        if (o.disabled){ b.disabled = true; }
        else {
          b.setAttribute('data-v', o.value);
          b.addEventListener('click', function(){
            if (sel.value === o.value) return;
            sel.value = o.value;
            sel.dispatchEvent(new Event('change', {bubbles: true}));
          });
        }
        box.appendChild(b);
      })(opts[i]);
    }
    function marcar(){
      var bs = box.querySelectorAll('button[data-v]');
      for (var j = 0; j < bs.length; j++){
        var on = bs[j].getAttribute('data-v') === sel.value;
        bs[j].classList.toggle('is-on', on);
        bs[j].setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }
    sel.addEventListener('change', marcar);
    sel.insertAdjacentElement('afterend', box);
    sel.classList.add('ab-sab-oculto');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');
    marcar();
  }

  /* ---------- 2. Mayoreo en pestaña ---------- */
  function mayoreo(){
    var t = document.getElementById('ab-tabla-escala');
    if (!t || t.closest('.ab-tab')) return;
    var d = document.createElement('details');
    d.className = 'ab-tab';
    var s = document.createElement('summary');
    s.textContent = 'Precio por pieza en mayoreo';
    d.appendChild(s);
    var form = document.querySelector('form[action*="/cart/add"]');
    var ancla = form ? form.closest('.product-block') : null;
    if (ancla && ancla.parentNode){ ancla.insertAdjacentElement('afterend', d); }
    else { t.insertAdjacentElement('beforebegin', d); }
    d.appendChild(t);
  }

  /* ---------- 3. Aparecer al bajar ---------- */
  function aparecer(){
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('.abr, .abc, .abo, .abe__box, .abk__g, .abk__w, .aby__in, .abh__in, .section-header, .product-recommendations');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08});
    for (var i = 0; i < els.length; i++){
      var r = els[i].getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) continue; /* lo que ya se ve al abrir no se anima */
      els[i].classList.add('ab-rev');
      io.observe(els[i]);
    }
  }

  function init(){
    sabores();
    mayoreo();
    aparecer();
    if (location.pathname.indexOf('/products/') > -1){
      /* la tabla de mayoreo aparece después (la dibuja ab-min-3.js) */
      var n = 0, iv = setInterval(function(){ mayoreo(); if (++n > 20 || document.querySelector('.ab-tab #ab-tabla-escala')) clearInterval(iv); }, 500);
    }
  }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
